import React from 'react';
import Headlines from '../components/Headlines';
import Sections from '../components/Sections';

const HomePage = ({ headerHeight }) => {
  return (
    <main style={{ paddingTop: `${headerHeight}px` }}>
      <Headlines />
      <Sections />
    </main>
  );
};

export default HomePage;
